module.exports = __webpack_public_path__ + "static/media/equipo.e145a5ff.jpg";